import { ISupplier } from "./psl.domain";
import { IMaterial } from "./pslMaterial.domain";
import { DateTime } from "luxon";

const waysTreeData = [
  { title: "Standard Purchase Order", value: 1 },
  { title: "Framework Order", value: 2 },
  { title: "Capex Purchase Order", value: 3 },
];
export const WOBLabel = (value) =>
  waysTreeData.find((x) => x.value === Number(value))?.title ?? String(value);

export interface IChange {
  auditId: string;
  auditDate: string;
  auditAction: "Update" | "Insert" | "Deleted" | "Delete";
  userName: string;
}

export interface ISupplierChange extends ISupplier, IChange {
  id: number;
  childCode: string;
  childName: string;
  marketsString: string;
  qualityApprovers?: string[] | null;
  incoterms?: string | null;

  pslVendorContact_Name?: string | null;
  pslVendorContact_Url?: string | null;
  pslVendorContact_Email?: string | null;
  pslVendorContact_Phone?: string | null;

  noteToRequester?: string | null;
  noteToProcurement?: string | null;
}
export interface IMaterialChange extends IMaterial, IChange {
  id: number;
  vendorId: number;

  pslSpendCategoryId?: number;
  spendCategoryString?: string;

  sapMaterialCode?: string;
  sapMaterialName?: string;
  shortDescription?: string;

  itemDescription?: string;
  manufacturerPartNumber?: string;
  supplierPartId?: string;
  unitOfMeasure?: string;

  minimumOrderQuantity?: number;
  minimumPurchaseQuantity?: number;
  unitPrice?: number | null;
  pricePer?: number | null;

  currencyString?: string;
  promoCategory?: string | null;
  qualityAttachments?: unknown | null;

  languageString?: string;
}
export interface IMaterialKeywordsChange extends IChange {
  id: number;
  pslMaterialId: number;
  value: string;
  created?: string;
}

export interface IMaterialPriceRangeChange extends IChange {
  id: number;
  pslMaterialId: number;
  quantity: number;
  price: number;
  pricePer: number;
  created?: string;
}

export interface IHistoryData {
  materialHistory: IMaterialChange[];
  vendorHistory: ISupplierChange[];
  materialKeywordsHistory: IMaterialKeywordsChange[];
  materialPriceRangesHistory: IMaterialPriceRangeChange[];
  materialPromoFilesHistory: any[];
}

export interface IHistory {
  field: string;
  action: string;
  value: string;
  oldValue: string;
  user: string;
  modifiedOn: string;
}

export function groupByMaterialId(data: IMaterialChange[]) {
  let material = [];
  data.forEach((materialChange) => {
    if (material[materialChange.id] === undefined) {
      material[materialChange.id] = [];
    }
    material[materialChange.id].push(materialChange);
  });
  return material;
}

export const historyDataToHistory = (data: IHistoryData): IHistory[] => {
  const materialsById = groupByMaterialId(data.materialHistory);
  let materialChangesById = [];
  materialsById.forEach((materials) => {
    const items = materialChangeToHistory(materials);
    materialChangesById = materialChangesById.concat(items);
  });
  return changeToHistory(data.vendorHistory)
    .concat(materialChangesById)
    .concat(materialKeywordsChangeToHistory(data.materialKeywordsHistory))
    .concat(materialPriceRangesChangeToHistory(data.materialPriceRangesHistory))
    .sort((a, b) => (a.modifiedOn > b.modifiedOn ? -1 : 1));
};

function formatDate(str) {
  const date = new Date(str);
  if (isNaN(date.getTime())) {
    return null; // return null if invalid date
  } else {
    return DateTime.fromJSDate(date).toFormat("dd/MM/yyyy");
  }
}
// function getHistoryEntries(
//   supplierChanges:
//     | ISupplierChange[]
//     | IMaterialChange[]
//     | IMaterialKeywordsChange[]
// ) {
//   let history: IHistory[] = [];
//   for (let i = supplierChanges.length - 1; i > 0; i--) {
//     const currentChange = supplierChanges[i];
//     const oldChange = supplierChanges[i - 1];
//     Object.keys(currentChange).map((currentSupplierKey) => {
//       if (
//         [
//           "auditId",
//           "auditDate",
//           "userName",
//           "auditAction",
//           "currencyId",
//           "languageId",
//           "pslVendorStatusId",
//           "code",
//           "name",
//           "parentMaterialId",
//         ].indexOf(currentSupplierKey) !== -1
//       ) {
//         return null;
//       }
//       const currentValue = JSON.stringify(currentChange[currentSupplierKey]);
//       const newValue = JSON.stringify(oldChange[currentSupplierKey]);
//       if (currentValue !== newValue) {
//         // to remove differences between [] and null or empty string
//         if (
//           (currentChange[currentSupplierKey] === null ||
//             currentChange[currentSupplierKey] === "" ||
//             (Array.isArray(currentChange[currentSupplierKey]) &&
//               currentChange[currentSupplierKey].length === 0)) &&
//           (oldChange[currentSupplierKey] === null ||
//             oldChange[currentSupplierKey] === "" ||
//             (Array.isArray(oldChange[currentSupplierKey]) &&
//               currentChange[currentSupplierKey].length === 0))
//         )
//           return null;
//         if (
//           currentSupplierKey === "languageString" &&
//           currentChange[currentSupplierKey] != null &&
//           oldChange[currentSupplierKey] === null &&
//           currentChange["languageId"] === oldChange["languageId"]
//         ) {
//           // to fix issue from backend
//           return null;
//         }
//         let value = currentChange[currentSupplierKey];
//         let oldValue = oldChange[currentSupplierKey];
//         // to fix when valid To and From dates have the same day with different hour:minutes
//         if (
//           currentSupplierKey === "validTo" ||
//           currentSupplierKey === "validFrom"
//         ) {
//           const valueDate = formatDate(value);
//           const valueOldDate = formatDate(oldValue);
//           console.log("value", valueDate, "old", valueOldDate);
//           if (value != null && valueDate != null && valueDate === valueOldDate) {
//             return null;
//           }
//         }
//         let action: string = currentChange.auditAction;
//         if (currentSupplierKey === "waysOfBuying") {
//           value = value
//             ?.split(",")
//             .map((x) => WOBLabel(x))
//             .join(",");
//           oldValue =
//             oldValue
//               ?.split(",")
//               .map((x) => WOBLabel(x))
//               .join(",") ?? "";
//         }
//         if (currentSupplierKey === "deleted") {
//           if ("vendorId" in currentChange && "id" in currentChange) {
//             currentSupplierKey = "Material";
//             const materialDescription =
//               currentChange.sapMaterialCode +
//               " - " +
//               currentChange.shortDescription;
//             if (value) {
//               value = "";
//               oldValue = materialDescription;
//               action = "Deleted";
//             } else {
//               value = materialDescription;
//               oldValue = "";
//               action = "Undeleted";
//             }
//           } else {
//             currentSupplierKey = "Psl Deleted";
//             action = value ? "Deleted" : "Reactivated";
//           }
//         }
//         if (currentSupplierKey === "pslStatus") {
//           if (value === 1) {
//             action =
//               "parentId" in currentChange && currentChange.parentId
//                 ? "Localized"
//                 : "Approved";
//           }
//           if (value === 2) action = "Rejected";
//         }
//         const change: IHistory = {
//           user: currentChange.userName,
//           modifiedOn: currentChange.auditDate,
//           action: action,
//           field: currentSupplierKey,
//           value: value,
//           oldValue: oldValue,
//         };
//         history.push(change);
//       }
//     return null
//     });
//   }
//   return history;
// }
// function getHistoryEntries(
//   supplierChanges:
//     | ISupplierChange[]
//     | IMaterialChange[]
//     | IMaterialKeywordsChange[]
// ) {
//   let history: IHistory[] = [];

//   // Sort a copy by auditDate so the original API response is not modified.
//   // This handles both smaller responses like 301 and larger history
//   // responses like 117.
//   const sortedChanges = [...supplierChanges].sort(
//     (a, b) =>
//       new Date(a.auditDate).getTime() -
//       new Date(b.auditDate).getTime()
//   );

//   // If there is only one history record, there is nothing to compare.
//   if (sortedChanges.length <= 1) {
//     return history;
//   }

//   for (let i = 1; i < sortedChanges.length; i++) {
//     const oldChange = sortedChanges[i - 1];
//     const currentChange = sortedChanges[i];

//     Object.keys(currentChange).map((currentSupplierKey) => {
//       if (
//         [
//           "auditId",
//           "auditDate",
//           "userName",
//           "auditAction",
//           "currencyId",
//           "languageId",
//           "pslVendorStatusId",
//           "code",
//           "name",
//           "parentMaterialId",
//         ].indexOf(currentSupplierKey) !== -1
//       ) {
//         return null;
//       }

//       const currentValue = JSON.stringify(
//         currentChange[currentSupplierKey]
//       );

//       const newValue = JSON.stringify(
//         oldChange[currentSupplierKey]
//       );

//       if (currentValue !== newValue) {
//         // to remove differences between [] and null or empty string
//         if (
//           (currentChange[currentSupplierKey] === null ||
//             currentChange[currentSupplierKey] === "" ||
//             (Array.isArray(currentChange[currentSupplierKey]) &&
//               currentChange[currentSupplierKey].length === 0)) &&
//           (oldChange[currentSupplierKey] === null ||
//             oldChange[currentSupplierKey] === "" ||
//             (Array.isArray(oldChange[currentSupplierKey]) &&
//               oldChange[currentSupplierKey].length === 0))
//         ) {
//           return null;
//         }

//         if (
//           currentSupplierKey === "languageString" &&
//           currentChange[currentSupplierKey] != null &&
//           oldChange[currentSupplierKey] === null &&
//           currentChange["languageId"] === oldChange["languageId"]
//         ) {
//           // to fix issue from backend
//           return null;
//         }

//         let value = currentChange[currentSupplierKey];
//         let oldValue = oldChange[currentSupplierKey];

//         // to fix when valid To and From dates have the same day
//         // with different hour:minutes
//         if (
//           currentSupplierKey === "validTo" ||
//           currentSupplierKey === "validFrom"
//         ) {
//           const valueDate = formatDate(value);
//           const valueOldDate = formatDate(oldValue);

//           console.log(
//             "value",
//             valueDate,
//             "old",
//             valueOldDate
//           );

//           if (
//             value != null &&
//             valueDate != null &&
//             valueDate === valueOldDate
//           ) {
//             return null;
//           }
//         }

//         let action: string = currentChange.auditAction;

//         if (currentSupplierKey === "waysOfBuying") {
//           value = value
//             ?.split(",")
//             .map((x) => WOBLabel(x))
//             .join(",");

//           oldValue =
//             oldValue
//               ?.split(",")
//               .map((x) => WOBLabel(x))
//               .join(",") ?? "";
//         }

//         if (currentSupplierKey === "deleted") {
//           if ("vendorId" in currentChange && "id" in currentChange) {
//             currentSupplierKey = "Material";

//             const materialDescription =
//               currentChange.sapMaterialCode +
//               " - " +
//               currentChange.shortDescription;

//             if (value) {
//               value = "";
//               oldValue = materialDescription;
//               action = "Deleted";
//             } else {
//               value = materialDescription;
//               oldValue = "";
//               action = "Undeleted";
//             }
//           } else {
//             currentSupplierKey = "Psl Deleted";
//             action = value ? "Deleted" : "Reactivated";
//           }
//         }

//         if (currentSupplierKey === "pslStatus") {
//           if (value === 1) {
//             action =
//               "parentId" in currentChange && currentChange.parentId
//                 ? "Localized"
//                 : "Approved";
//           }

//           if (value === 2) {
//             action = "Rejected";
//           }
//         }

//         const change: IHistory = {
//           user: currentChange.userName,
//           modifiedOn: currentChange.auditDate,
//           action: action,
//           field: currentSupplierKey,
//           value: value,
//           oldValue: oldValue,
//         };

//         history.push(change);
//       }

//       return null;
//     });
//   }

//   return history;
// }
function getHistoryEntries(
  supplierChanges:
    | ISupplierChange[]
    | IMaterialChange[]
    | IMaterialKeywordsChange[]
) {
  let history: IHistory[] = [];

  if (!supplierChanges || supplierChanges.length <= 1) {
    return history;
  }

  // Create a copy and sort chronologically.
  // This supports API responses that may come in either
  // ascending or descending auditDate order.
  const sortedChanges = [...supplierChanges].sort(
    (a, b) =>
      new Date(a.auditDate).getTime() -
      new Date(b.auditDate).getTime()
  );

  for (let i = 1; i < sortedChanges.length; i++) {
    const oldChange = sortedChanges[i - 1];
    const currentChange = sortedChanges[i];

    Object.keys(currentChange).forEach((currentSupplierKey) => {
      if (
        [
          "auditId",
          "auditDate",
          "userName",
          "auditAction",
          "currencyId",
          "languageId",
          "pslVendorStatusId",
          "code",
          "name",
          "parentMaterialId",
        ].includes(currentSupplierKey)
      ) {
        return;
      }

      const currentValue = JSON.stringify(
        currentChange[currentSupplierKey]
      );

      const oldValueJson = JSON.stringify(
        oldChange[currentSupplierKey]
      );

      // No change in this field
      if (currentValue === oldValueJson) {
        return;
      }

      // Remove differences between null, empty string and empty array
      const currentFieldValue = currentChange[currentSupplierKey];
      const oldFieldValue = oldChange[currentSupplierKey];

      const isEmptyValue = (value: any) =>
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0);

      if (
        isEmptyValue(currentFieldValue) &&
        isEmptyValue(oldFieldValue)
      ) {
        return;
      }

      // Backend language inconsistency fix
      if (
        currentSupplierKey === "languageString" &&
        currentFieldValue != null &&
        oldFieldValue === null &&
        currentChange["languageId"] === oldChange["languageId"]
      ) {
        return;
      }

      let value = currentFieldValue;
      let oldValue = oldFieldValue;

      // Handle validFrom / validTo date differences where only
      // the time portion is different.
      if (
        currentSupplierKey === "validTo" ||
        currentSupplierKey === "validFrom"
      ) {
        const valueDate = formatDate(value);
        const valueOldDate = formatDate(oldValue);

        if (
          value != null &&
          valueDate != null &&
          valueDate === valueOldDate
        ) {
          return;
        }
      }

      let action: string = currentChange.auditAction;

      // Ways of Buying
      if (currentSupplierKey === "waysOfBuying") {
        value = value
          ?.split(",")
          .map((x) => WOBLabel(Number(x)))
          .join(",");

        oldValue =
          oldValue
            ?.split(",")
            .map((x) => WOBLabel(Number(x)))
            .join(",") ?? "";
      }

      // Deleted / Undeleted handling
      if (currentSupplierKey === "deleted") {
        if ("vendorId" in currentChange && "id" in currentChange) {
          currentSupplierKey = "Material";

          const materialDescription =
            currentChange.sapMaterialCode +
            " - " +
            currentChange.shortDescription;

          if (value) {
            value = "";
            oldValue = materialDescription;
            action = "Deleted";
          } else {
            value = materialDescription;
            oldValue = "";
            action = "Undeleted";
          }
        } else {
          currentSupplierKey = "Psl Deleted";
          action = value ? "Deleted" : "Reactivated";
        }
      }

      // PSL Status handling
      if (currentSupplierKey === "pslStatus") {
        if (value === 1) {
          action =
            "parentId" in currentChange && currentChange.parentId
              ? "Localized"
              : "Approved";
        }

        if (value === 2) {
          action = "Rejected";
        }
      }

      const change: IHistory = {
        user: currentChange.userName,
        modifiedOn: currentChange.auditDate,
        action: action,
        field: currentSupplierKey,
        value: value,
        oldValue: oldValue,
      };

      history.push(change);
    });
  }

  return history;
}
// export const changeToHistory = (
//   supplierChanges: ISupplierChange[]
// ): IHistory[] => {
//   if (supplierChanges.length <= 0) {
//     return [];
//   }
//   const initialChange = supplierChanges[0];
//   let history: IHistory[] = [];
//   const change: IHistory = {
//     action: "Entered",
//     field: "Supplier",
//     value: `${initialChange?.childCode} - ${initialChange?.childName}`,
//     user: initialChange.userName,
//     modifiedOn: initialChange.auditDate,
//     oldValue: "",
//   };

//   const locationChange: IHistory = {
//     action: "Entered",
//     field: "Location",
//     value: initialChange.marketsString,
//     user: initialChange.userName,
//     modifiedOn: initialChange.auditDate,
//     oldValue: "",
//   };

//   history.push(change);
//   history.push(locationChange);
//   return history.concat(getHistoryEntries(supplierChanges));
// };
export const changeToHistory = (
  supplierChanges: ISupplierChange[]
): IHistory[] => {
  if (supplierChanges.length <= 0) {
    return [];
  }

  const sortedSupplierChanges = [...supplierChanges].sort(
    (a, b) =>
      new Date(a.auditDate).getTime() -
      new Date(b.auditDate).getTime()
  );

  const initialChange = sortedSupplierChanges[0];

  let history: IHistory[] = [];

  const change: IHistory = {
    action: "Entered",
    field: "Supplier",
    value: `${initialChange?.childCode} - ${initialChange?.childName}`,
    user: initialChange.userName,
    modifiedOn: initialChange.auditDate,
    oldValue: "",
  };

  const locationChange: IHistory = {
    action: "Entered",
    field: "Location",
    value: initialChange.marketsString,
    user: initialChange.userName,
    modifiedOn: initialChange.auditDate,
    oldValue: "",
  };

  history.push(change);
  history.push(locationChange);

  return history.concat(getHistoryEntries(sortedSupplierChanges));
};
export const materialChangeToHistory = (
  supplierChanges: IMaterialChange[]
): IHistory[] => {
  const initialChange = supplierChanges[0];
  let history: IHistory[] = [];
  const change: IHistory = {
    action: "Entered",
    field: "Material",
    value:
      initialChange.sapMaterialCode + " - " + initialChange.shortDescription,
    user: initialChange.userName,
    modifiedOn: initialChange.auditDate,
    oldValue: "",
  };
  history.push(change);
  return history.concat(getHistoryEntries(supplierChanges));
};

const formatPartialDate = (date: string) => date.substring(0, 19);
export const materialKeywordsChangeToHistory = (
  supplierChanges: IMaterialKeywordsChange[]
): IHistory[] => {
  if (!supplierChanges) return [];

  const historyMap = new Map<string, IHistory>();
  for (const x of supplierChanges) {
    let key = `${x.pslMaterialId}_${formatPartialDate(x.auditDate)}`;

    if (x.auditAction === "Insert") {
      let entry = historyMap.get(key);
      if (entry) {
        if (entry.action === "Insert") {
          key = `${key}_${generateRandomString()}`;
          entry = null;
        }
      }

      if (!entry) {
        entry = {
          action: "Insert",
          field: "Keywords",
          value: x.value,
          user: x.userName,
          modifiedOn: x.auditDate,
          oldValue: "",
        };
      }
      historyMap.set(key, entry);
    } else if (x.auditAction === "Delete") {
      if (historyMap.has(key)) {
        const entry = historyMap.get(key)!;
        entry.action = "Update";
        entry.oldValue = x.value;
      } else {
        historyMap.set(key, {
          action: "Delete",
          field: "Keywords",
          value: x.value,
          user: x.userName,
          modifiedOn: x.auditDate,
          oldValue: "",
        });
      }
    }
  }

  return Array.from(historyMap.values());
};

function generateRandomString() {
  return (Math.random() * 1e32).toString(36).substring(0, 10);
}

export const materialPriceRangesChangeToHistory = (
  priceRangeChanges: IMaterialPriceRangeChange[]
): IHistory[] => {
  if (!priceRangeChanges) return [];

  // Group changes by material ID and timestamp to handle multiple changes at the same time
  const groupedChanges = new Map<string, IMaterialPriceRangeChange[]>();

  for (const x of priceRangeChanges) {
    const key = `${x.pslMaterialId}_${formatPartialDate(x.auditDate)}`;
    if (!groupedChanges.has(key)) {
      groupedChanges.set(key, []);
    }
    groupedChanges.get(key)!.push(x);
  }

  const result: IHistory[] = [];

  groupedChanges.forEach((changes, key) => {
    const inserts = changes.filter(x => x.auditAction === "Insert");
    const deletes = changes.filter(x => x.auditAction === "Delete");

    // Create maps to track which values were inserted and deleted
    const insertedValues = new Map<string, IMaterialPriceRangeChange>();
    const deletedValues = new Map<string, IMaterialPriceRangeChange>();

    inserts.forEach(insert => {
      const valueKey = `Qty: ${insert.quantity}, Price: ${insert.price}, PricePer: ${insert.pricePer}`;
      insertedValues.set(valueKey, insert);
    });

    deletes.forEach(deleteItem => {
      const valueKey = `Qty: ${deleteItem.quantity}, Price: ${deleteItem.price}, PricePer: ${deleteItem.pricePer}`;
      deletedValues.set(valueKey, deleteItem);
    });

    // Find delete-insert pairs with identical values (these should be ignored)
    const identicalPairs = new Set<string>();
    insertedValues.forEach((insert, valueKey) => {
      if (deletedValues.has(valueKey)) {
        identicalPairs.add(valueKey);
      }
    });

    // Remove identical pairs from both maps
    identicalPairs.forEach(valueKey => {
      insertedValues.delete(valueKey);
      deletedValues.delete(valueKey);
    });

    // Handle remaining pairs as updates (different values)
    const updatePairs = new Map<string, { oldValue: string; newValue: string; user: string; date: string }>();

    // Find pairs that can be matched as updates
    insertedValues.forEach((insert, insertValueKey) => {
      deletedValues.forEach((deleteItem, deleteValueKey) => {
        if (insertValueKey !== deleteValueKey) {
          updatePairs.set(`${deleteValueKey}->${insertValueKey}`, {
            oldValue: deleteValueKey,
            newValue: insertValueKey,
            user: insert.userName,
            date: insert.auditDate
          });

          insertedValues.delete(insertValueKey);
          deletedValues.delete(deleteValueKey);
          return;
        }
      });
    });

    updatePairs.forEach((pair, pairKey) => {
      result.push({
        action: "Update",
        field: "Price Range",
        value: pair.newValue,
        oldValue: pair.oldValue,
        user: pair.user,
        modifiedOn: pair.date,
      });
    });

    insertedValues.forEach((insert, valueKey) => {
      result.push({
        action: "Insert",
        field: "Price Range",
        value: valueKey,
        user: insert.userName,
        modifiedOn: insert.auditDate,
        oldValue: "",
      });
    });

    deletedValues.forEach((deleteItem, valueKey) => {
      result.push({
        action: "Delete",
        field: "Price Range",
        value: valueKey,
        user: deleteItem.userName,
        modifiedOn: deleteItem.auditDate,
        oldValue: "",
      });
    });
  });

  return result;
};
